import './PardotEmailTemplate.scss';
import { ifClickHandler } from '@lib/events';
import { SonarRecord } from '@ui/records';
import { PeriscopePardotEmailTemplate, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export interface PardotEmailTemplateProps {
	entity: PeriscopePardotEmailTemplate;
	onEmailTemplateClick: EmailTemplateClickHandler;
}

export type EmailTemplateClickHandler = (emailTemplate: PeriscopePardotEmailTemplate) => void;

export const PardotEmailTemplate: React.FC<PardotEmailTemplateProps> = ({ entity, onEmailTemplateClick }) => {
	const { displayName } = entity;

	const handleOnClick = useMemo(() => ifClickHandler(onEmailTemplateClick, entity), [ entity, onEmailTemplateClick ]);

	return (
		<div className='pardot-email-template'>
			<SonarRecord
				name={ displayName }
				onClick={ handleOnClick }
				sonarObjectId={ entity.sonarObjectId }
				sonarObjectType={ SonarObjectType.PardotEmailTemplate } />
		</div>
	);
};
